export default "__VITE_ASSET__ENmtSX0$__"